import { validator } from "@/utils/validator";

export const informationSchema = validator.object().shape({
  type: validator.string().isSelection().label("タグ").required(),
  recipientType: validator.string().isSelection().label("カテゴリ").required(),
  title: validator.string().emptyToNull().label("タイトル").required(),
  content: validator.string().emptyToNull().label("本文").required(),
  startDate: validator
    .mixed()
    .isSelection()
    .isDayjs()
    .when("enableStartDate", ([enableStartDate], schema) => {
      if (enableStartDate) return schema.required();
      return schema.nullable();
    })
    .label("公開開始日")
    .required()
    .nullable(),
  endDate: validator
    .mixed()
    .isSelection()
    .isDayjs()
    .isSameOrAfterDate("startDate", { startLabel: "公開開始日", endLabel: "公開終了日" })
    .when("enableEndDate", ([enableStartDate], schema) => {
      if (enableStartDate) return schema.required();
      return schema.nullable();
    })
    .label("公開終了日")
    .required()
    .nullable(),
  enableStartDate: validator.boolean().required(),
  enableEndDate: validator.boolean().required(),
  filePath: validator.string().emptyToNull().label("ファイル添付").required().nullable(),
});
